import { gql } from "@apollo/client"

export const GET_ACT_ADMIN = gql`
  query getACTAdmin($id: String!) {
    actAdmin {
      get(id: $id) {
        id
        firstName
        lastName
        email
        username
        title
        isTeacher
        isIT
        sfId
      }
    }
  }
`
